/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import KfreTwoYearsComputedJournalEvent from "pro-irc/models/kfre-two-years-computed-journal-event";
import { computeKfreAsPercent } from "pro-irc/utils/compute-kfre";
import BaseKfreEditionForm from "../abstract/base-kfre-edition-form";
export default class KfreTwoYearsEditionFormComponent extends BaseKfreEditionForm {
  computeScore(o) {
    return computeKfreAsPercent({
      age: parseFloat(o.age),
      sex: o.sex,
      dfg: parseFloat(o.dfg),
      rac: parseFloat(o.rac),
      years: 2
    }).toString();
  }
}
_defineProperty(KfreTwoYearsEditionFormComponent, "forcDisplayName", "Score de risque rénal à 2 ans");
_defineProperty(KfreTwoYearsEditionFormComponent, "fullComponentId", "kfre/two-years-edition-form");
_defineProperty(KfreTwoYearsEditionFormComponent, "journalEventClass", KfreTwoYearsComputedJournalEvent);